// LOUNGE (§13.4): F major, 112.5 BPM, lo-fi bossa. EP comping (rootless), upright-ish FM bass on
// the baião figure (root, fifth on 2&, fifth on 3, root on 4&), cross-stick clave, brush swirls and
// a marimba melody. Used by the Lobby, the menu and the Locker. A: Ipanema-style I–II7–ii–bII7
// changes; B: IV–iv–bVII7 then a iii–VI7–ii–V turnaround home.
import type { SongDef } from '../songTypes';

export const LOUNGE: SongDef = {
  id: 'lounge',
  rootMidi: 65,
  scale: 'major',
  swing: 0.08,
  bars: 16,
  chords: [
    'Imaj7', 'Imaj7', 'V7/V', 'V7/V', 'ii7', 'bII7', 'Imaj7', 'V7/IV',
    'IVmaj7', 'IVmaj7', 'iv7', 'bVII7', 'iii7', 'V7/ii', 'ii7', 'V7',
  ],
  drums: { kick: 'x.....x.x.....x.', snare: 'x..x..x...x..x..', hat: 'x.o.x.oox.o.x.oo', perc: 'x.......x.......' },
  drumsB: { kick: 'x.....x.x.....x.', snare: '..x..x...x..x...', hat: 'x.o.x.oox.o.x.oo', perc: 'x.......x.......' },
  fill: { kick: 'x.....x.x.......', snare: 'x..x..x...x.rrxX', hat: 'x.o.x.o.x.......', perc: '................' },
  pickup: { kick: '................', snare: '........o..o.rxX', hat: 'x.o.x.o.x.o.x.o.' },
  bass: [
    'F2 - - - - - C2 - C2 - - - - - F2 -',
    'F2 - - - - - C2 - C2 - - - - - E2 -',
    'G2 - - - - - D2 - D2 - - - - - G2 -',
    'G2 - - - - - D2 - D2 - - - - - A2 -',
    'G2 - - - - - D2 - D2 - - - - - G2 -',
    'Gb2 - - - - - Db2 - Db2 - - - - - Gb2 -',
    'F2 - - - - - C2 - C2 - - - - - F2 -',
    'F2 - - - - - C2 - C2 - - - - - A1 -',
    'Bb1 - - - - - F2 - F2 - - - - - Bb1 -',
    'Bb1 - - - - - F2 - F2 - - - - - A1 -',
    'Bb1 - - - - - F2 - F2 - - - - - Db2 -',
    'Eb2 - - - - - Bb1 - Bb1 - - - - - Bb1 -',
    'A1 - - - - - E2 - E2 - - - - - A1 -',
    'D2 - - - - - A1 - A1 - - - - - D2 -',
    'G1 - - - - - D2 - D2 - - - - - G1 -',
    'C2 - - - - - G1 - G1 - - - - - E2 -',
  ],
  lead: [
    'E5 - - - - - D5 - C5 - - - A4 - - -',
    'G4 - A4 - C5 - - - . . . . A4 - C5 -',
    'D5 - - - - - B4 - D5 - - - F5 - - -',
    'E5 - D5 - B4 - - - . . . . G4 - A4 -',
    'Bb4 - - - - - A4 - G4 - - - F4 - - -',
    'Bb4 - - - Db5 - - - E5 - - - Db5 - - -',
    'C5 - - - - - A4 - F4 - - - . . A4 -',
    'C5 - Eb5 - - - D5 - C5 - - - A4 - - -',
    'D5 - - - - - F5 - A5 - - - - - - -',
    'G5 - F5 - D5 - - - C5 - - - D5 - - -',
    'Db5 - - - - - F5 - Ab5 - - - - - - -',
    'G5 - F5 - Eb5 - - - Db5 - - - C5 - - -',
    'C5 - - - - - E5 - G5 - - - - - E5 -',
    'F#5 - - - E5 - D5 - C5 - - - A4 - - -',
    'Bb4 - - - D5 - F5 - A5 - - - G5 - F5 -',
    'E5 - D5 - C5 - - - Bb4 - - - G4 - - -',
  ],
  arp: '. . 5 . . 8 . . 10 . . 8 . . 5 .',
  comp: 'X-.o..x-.o..x-..',
  compB: 'x-.o..x-.o..X-.o',
  voicing: 'rootless',
  chordRange: [53, 72],
  instruments: { bass: 'upright', chords: 'ep', lead: 'marimba', arp: 'nylon', perc: 'brushSwish' },
  kit: { kick: 'kickSoft', snare: 'rim', hat: 'hat', crash: 'ride' },
  stabs: 'X.....x.........',
  mix: { hat: -6, perc: -4, arp: -5, chords: -2 },
};
